import { render, staticRenderFns } from "./NewsflashSettingsTab.vue?vue&type=template&id=d18e4fc6&scoped=true&"
import script from "./NewsflashSettingsTab.vue?vue&type=script&lang=js&"
export * from "./NewsflashSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./NewsflashSettingsTab.vue?vue&type=style&index=0&id=d18e4fc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18e4fc6",
  null
  
)

export default component.exports